<template>
    <div class="infoengine">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-6">
                    <h2 class="filter-heading">
                        Document Verification Factors
                    </h2>
                </div>
            </div>
        </div>
        <div
            :class="[
                'table-section',
                'tablet-table-small-min-width',
                'remove-sort-icon',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table :items="data" :fields="fields">
                <template slot="action" slot-scope="data">
                    <div class="action-review">
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('modify-liveness-detection-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <base-records
            path="configurations/document-thresholds"
            :query="query"
            :reset="reset"
            :show-pagination="false"
        ></base-records>
        <modify-liveness-detection-popup></modify-liveness-detection-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import modifyLivenessDetectionPopup from '@/components/popups/ModifyLivenessDetectionPopup.vue'
export default {
    components: {
        modifyLivenessDetectionPopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fields: [
                {
                    key: 'code',
                    label: 'Verification Code',
                    class: 'w-320px',
                    sortable: false,
                },
                {
                    key: 'type',
                    label: 'Verification Type',
                    class: 'text-center',
                    sortable: false,
                },
                {
                    key: 'threshold',
                    label: 'Matched Scored Threshold',
                    class: 'text-center',
                    sortable: false,
                },
                {
                    key: 'action',
                    label: 'ACTION',
                    class: 'single-list',
                },
            ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 100,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'code',
                sortOrder: 'asc',
            },
            reset: new Date().getTime(),
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'showPageLoader', 'loading']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
        }, // End of sortingChanged() method
    }, // End of Component > mounted
} // End of export default
</script>
